<template>


  <section class="mt-4 px-24 sm-max:px-5 md-max:mt-10">
    <div class="max-w-4xl m-auto mb-16 md-max:mb-10 md-max:pt-10">

      <div class="grid lg:grid-cols-12 bg-[#ebecef] px-8 lg:mx-7 py-12 md-max:py-6 mt-20 md-max:mt-0 md-max:pb-14">
        <div class="col-span-3 md-max:col-span-12 md-max:pb-4">
          <nuxt-img
              class="m-auto md-only:my-2 sm-max:pb-4"
              loading="lazy"
              width="116"
              height="173"
              :alt="imageAlt"
              :src="imageSrc"
          ></nuxt-img>
        </div>
        <div class="col-span-9 space-y-5 md-max:col-span-12 lg:-ml-2">
          <h3 class="md:text-28 text-xl leading-head" v-html="Title"></h3>
          <div class="md:text-19 text-17 leading-30 sm-max:text-base" v-html="description"></div>
          <div class="md:text-19 text-17 leading-30 sm-max:text-base" v-html="description1"></div>
        </div>

      </div>

    </div>

  </section>


</template>

<script setup>

defineProps({
  imageAlt: {
    type: String,
    default: 'Drink Coffee and Save the Planet'
  },
  imageSrc: {
    type: String,
    default: '/assets/images/freebag-tiger.jpg'
  },
  Title: {
    type: String,
    default: '“Drink Coffee and Save the Planet”'
  },
  description: {
    type: String,
    default: 'A Portion of the profit from each bag you purchase will be donated to: www.rainforesttrust.org'
  },
  description1: {
    type: String,
    default: 'Rainforest Trust is able to allocate 100% of YOUR donation DIRECTLY to conservation!'
  },


})


defineBuilderComponent({
    friendlyName: "DrinkCoffee",
    canHaveChildren: true,
    inputs: [
        {
            name: "imageAlt",
            type: "richText",
            defaultValue: "Drink Coffee and Save the Planet"
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/freebag-tiger.jpg",
            required: true
        },
        {
            name: "Title",
            type: "richText",
            defaultValue: "“Drink Coffee and Save the Planet”"
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "A Portion of the profit from each bag you purchase will be donated to: www.rainforesttrust.org"
        },
        {
            name: "description1",
            type: "richText",
            defaultValue: "Rainforest Trust is able to allocate 100% of YOUR donation DIRECTLY to conservation!"
        }
    ]
});
</script>